const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource,
  updateTransientContext
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate objectMapBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined || !isPlainObject(object)) {
    return undefined;
  }
  const transientContextMap = await evaluateSource(source.contextMap || source.transientContextMap, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  const keys = Object.keys(object);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const value = object[key];
    const childTransientContext = JSON.parse(JSON.stringify(transientContext));
    updateTransientContext(childTransientContext, transientContextMap, {
      object,
      key,
      value
    });
    const resultKey = source.keyTransform === undefined ? key
    // eslint-disable-next-line no-await-in-loop
    : await evaluateSource(source.keyTransform, content, parentContentPath, childTransientContext, nativeFunctions);
    const resultValue = source.valueTransform === undefined ? value
    // eslint-disable-next-line no-await-in-loop
    : await evaluateSource(source.valueTransform, content, parentContentPath, childTransientContext, nativeFunctions);
    if (resultKey !== undefined && resultValue !== undefined) {
      result[resultKey] = resultValue;
    }
  }
  return result;
};
module.exports = {
  evaluate
};